import { Component, OnInit } from '@angular/core';
import {PaiuLeadService} from '../../shared/services/paiu-lead.service';
import {StorageService} from '../../shared/services/storage.service';

@Component({
  selector: 'app-paiu-transaction',
  templateUrl: './paiu-transaction.component.html',
  styleUrls: ['./paiu-transaction.component.scss']
})
export class PaiuTransactionComponent implements OnInit {
    showSearch = false;
    user: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 30,
        pages: null
    };
    submitting: any = false;
    transactions = [];
    constructor(
        private paiuLeadService: PaiuLeadService,
    ) {  this.user = StorageService.getItem('self'); }

    ngOnInit(): void {
        this.refresh();
    }
    refresh() {
        this.get();
    }
    get(params: any = {}) {
        params.page = this.pagination.page;
        params.per_page = this.pagination.perpage;
        this.submitting = true;
        this.transactions = [];
        this.paiuLeadService.getTransaction(params).subscribe(data => {
                if (data && data['data'] && data['data'].length > 0) {
                    this.transactions = data['data'];
                    this.pagination = {
                        page: data.current_page,
                        total: data.total,
                        perpage: data.per_page,
                        pages: data.last_page,
                    };
                } else {
                    this.transactions = [];
                }
                this.submitting = false;
            }, error => {
                this.submitting = false;
            }
        );
    }
    onPageChange(page) {
        this.pagination.page = page;
        const params = {
            // 'name': (this.searchForm && this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : ''
        };
        this.get(params);
    }
}
